export var masterFirebaseConfig = {
  apiKey: "AIzaSyCeKmfy8lGljsnKvXqf6Kod0JY1hXwZp3U",
  authDomain: "molenomore-1e8ed.firebaseapp.com",
  databaseURL: "https://molenomore-1e8ed.firebaseio.com",
  projectId: "molenomore-1e8ed",
  storageBucket: "molenomore-1e8ed.appspot.com",
  messagingSenderId: "255571183217",
  mapKey: 'AIzaSyBnR7tG8Wq-o-DPFMG1LMzoW-ndo-3hhRg'
};



// WEBPACK FOOTER //
// ./src/app/api-keys.ts